export default __webpack_public_path__ + "static/media/tiktok.3cb3c0ad.svg";